import React, { useState } from "react";
import "./A1DeviceSwitch.css";

const A1DeviceSwitch = ({ item, inputValue }) => {
  const [selectedDevices, setSelectedDevices] = useState([]);

  let devices =[]
  try {
    devices = JSON.parse(item?.text);
  } catch (e) {
    return null;
  }

 

  
  const handleDeviceClick = (value) => {
    const newSelected = selectedDevices.includes(value)
      ? selectedDevices.filter(v => v !== value)
      : [...selectedDevices, value];
    
    if (newSelected.length > 0) {
      inputValue?.current?.removeAttribute("disabled");
    } else {
      inputValue?.current?.setAttribute("disabled", true);
    }
    
    setSelectedDevices(newSelected);
    const formattedValue = `${newSelected.join(',')}`;
    localStorage.setItem("inputValue", JSON.stringify({ key1: formattedValue }));
    if (inputValue?.current) {
      inputValue.current.value = formattedValue;
    }
  };

  return (
    <div className="a1-device-wrapper action-tab">
      {devices.map((device, index) => (
        <div 
          className="a1-device-card" 
          key={index}
          onClick={() => handleDeviceClick(device.value)}
          style={{ cursor: 'pointer' }}
        >
          {/* Content */}
          <div className="a1-device-content action-tab">
            <div className="a1-device-name">
              <img src={device.deviceIcon || "https://mediaready.videoready.tv/tatasky/image/fetch/f_auto,fl_lossy,q_auto,w_40,h_40/https://tstatic.videoready.tv/cms-ui/images/custom-content/1729271369390.png"} alt={device.deviceName} style={{ height: '20px', width: '20px' }} />
              {device.deviceName}
            </div>
            <div
              className="a1-device-activity"
              dangerouslySetInnerHTML={{ __html: device.lastActivity }}
            />
          </div>

          {/* Right status */}
          <div className="a1-device-status action-tab">
            {selectedDevices.includes(device.value) ? (
              <img src="https://www.tataplaybinge.com/assets/images/check-icon.2b15f2c00661d77b1b76.svg" alt="selected" style={{ width: '20px', height: '20px' }} />
            ) : device.currentDevice ? (
              <span className="a1-current-device">This Device</span>
            ) : (
              <span className="a1-inactive-dot" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default A1DeviceSwitch;
